// extracted by mini-css-extract-plugin
module.exports = {"onLinkHover":"Table_onLinkHover__3gxrK","onHoverRow":"Table_onHoverRow__1d24z"};